import {BigDecimal} from '@dms/api/shared';

export type PriceExtra = {
  readonly vatDeductible: boolean;
  readonly vatRate: BigDecimal | null;
  readonly vatCode: string;
  readonly countryCode: string | undefined;
};
